<template>
    <div id="gas-station-search" class="input-group">
        <div class="input-group-prepend">
            <span class="input-group-text" id="search-addon">
                <i class="icon-gas text-primary"></i>
            </span>
        </div>
        <input
            id="gas-station-finder--input"
            type="search"
            v-model="term"
            ref="input"
            class="form-control"
            placeholder="Tankstelle suchen (Ort oder PLZ)"
            aria-label="Tankstelle suchen"
            aria-describedby="search-addon">
        <div id="search-results">
            <div class="card-list">
                <transition-group tag="div" name="staggered">
                    <ResultsTemplate
                        v-for="result in methodResults"
                        :key="result.item.tid"
                        :item="result.item"
                        @item-clicked="stationSelected(result.item)"
                        @click="term = ''"></ResultsTemplate>
                </transition-group>
                <transition-group tag="div" name="staggered">
                    <PlaceResultsTemplate
                        v-if="!methodResults.length"
                        v-for="item in placesResults"
                        :key="item.place_id"
                        :item="item"
                        @place-clicked="placeSelected(item)"
                        @click="term = ''"></PlaceResultsTemplate>
                </transition-group>
            </div>
        </div>
<!--        <div class="input-group-append">
            <a class="btn btn-outline-primary search-link" href="/tanken/tankstellenfinder.html" alt="Erweiterte Suche">Erweiterte Suche</a>
        </div>-->
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import ResultsTemplate from './resultsTemplate.vue'
    import PlaceResultsTemplate from './placeResultsTemplate.vue'
    import {loaded} from 'vue2-google-maps'

    export default {
        components: {ResultsTemplate, PlaceResultsTemplate},
        data() {
            return {
                term: '',
                termtwo: '',
                defaultAllToggle: false,
                options: {
                    shouldSort: true,
                    tokenize: true,
                    matchAllTokens: true,
                    includeScore: true,
                    includeMatches: true,
                    threshold: 0.4,
                    location: 0,
                    distance: 100,
                    maxPatternLength: 32,
                    minMatchCharLength: 3,
                    keys: [
                        "tankstelle",
                        "address.city",
                        "address.street",
                        "address.zip"
                    ]
                },
                componentResults: [],
                methodResults: [],
                placesResults: [],
                keys: [
                    "tankstelle",
                    "address.city",
                    "address.street",
                    "address.zip"
                ]
            }
        },
        computed: {
            ...mapGetters({
                stations: 'stations'
            })
        },
        methods: {
            ...mapActions([
                'setSelectedStation',
                'setSelectedPlace'
            ]),
            stationSelected(item) {
                this.componentResults = []
                this.methodResults = []
                this.placesResults = []
                console.log('click')
                this.setSelectedStation(item.tid)
                if (!(window.location.pathname === '/tanken/tankstellenfinder.html')) {
                    window.location.pathname = '/tanken/tankstellenfinder.html'
                }
            },
            placeSelected(item) {
                this.componentResults = []
                this.methodResults = []
                this.placesResults = []
                this.setSelectedPlace(item)
                if (!(window.location.pathname === '/tanken/tankstellenfinder.html')) {
                    window.location.pathname = '/tanken/tankstellenfinder.html'
                }
            },
            geoCodeAddress(term) {
                console.log('GeoCodeing...')
                let geocoder = new google.maps.Geocoder
                return new Promise(function (resolve, reject) {
                    geocoder.geocode({
                        'address': term,
                        componentRestrictions: {country: 'DE'}
                    }, function (places, status) {
                        if (status === 'OK') {
                            if (places) {
                                resolve(places)
                                //console.log(places)
                            } else {
                                reject(status)
                                console.error('No results found', status)
                            }
                        }
                    })
                })
            }
        },
        watch: {
            term() {
                this.$search(this.term, this.stations, this.options).then(results => {
                    this.methodResults = results
                })
                if (this.term.length) {
                    this.geoCodeAddress(this.term).then((result) => {
                        this.placesResults = result
                    })
                }
            }
        },
        created() {
            this.$on('stationsChanged', results => {
                this.componentResults = results
            })
        },
        mounted() {
            //console.log('loaded')
        }
    }
</script>

<style lang="scss">
    #gas-station-finder--input {
        //background: rgba(186, 12, 47, 0.3);
        color: rgba(0, 48, 135, 0.95);
        &::placeholder {
            color: rgba(0, 48, 135, 0.95);
        }
    }
    #sprint_station_search_mobile {
        width: 350px;
        .btn-outline-primary {
            color: #BA0C2F;
            background-color: #e9ecef !important;
            background-image: none !important;
            border-color: #ced4da !important;
        }
        #gas-station-search {
            height: 50px;
            .input-group-text {
                border-bottom-left-radius: 0 !important;
                border-top-left-radius: 0 !important;
            }
        }
        &.mobile {
            width: 100%;
            display: block;
            margin-top: 75px;
            padding-bottom: 0;

            #search-results {
                position: absolute;
                top: 100%;
                right: 0;
                background: white;
                max-height: calc(100vh - (75px + 50px));
                overflow-y: auto;
                padding: 0 .25rem;
                width: 100%;
                z-index: 99;
            }
        }
    }

    #sprint_station_search_desktop {
        width: 350px;
        .btn-outline-primary {
            color: #BA0C2F;
            background-color: #e9ecef !important;
            background-image: none !important;
            border-color: #ced4da !important;
        }
        &.desktop {

            #search-results {
                position: absolute;
                top: 100%;
                right: 0;
                background: white;
                max-height: 75vh;
                overflow-y: auto;
                padding: .25rem;
                width: calc(100% - 42px);
            }
        }
    }

    #gas-station-search {
        position: relative;
    }

    #search-results {
        position: absolute;
        top: 100%;
        right: 151.86px;
        background: white;
        max-height: 75vh;
        overflow-y: auto;
        padding: .25rem;
        width: 309px;
    }

    .no-item-fade-enter-active, .no-item-fade-leave-active,
    .fade-enter-active, .fade-leave-active {
        transition: all 1s ease .5s;
    }

    .no-item-fade-enter, .no-item-fade-leave-to,
    .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */
    {
        opacity: 0
    }

    .no-item-fade-enter, .no-item-fade-leave-to {
        height: 0;
        margin-bottom: 0;
    }

    /* stagger css */
    .staggered-enter-active, .staggered-leave-active {
        transition: all .8s ease-in;
        overflow: hidden;
        margin: 0;
        height: 100%;

    }

    .staggered-enter, .staggered-leave-to {
        opacity: 0;
        height: 0;
    }


</style>



// WEBPACK FOOTER //
// SearchWidget.vue?22d10302